/* eslint-disable react/display-name */
import { useState, useRef, useEffect, forwardRef } from "react";
import PropTypes from "prop-types";
import { useComposedRefs, useInView } from "@gonoodle/gn-universe-utils";

import { ImageSourcesType } from "../Image/types";
import Image from "../Image";

const BackgroundVideo = forwardRef(
  ({ source, fallbackImage, ...rest }, forwardedRef) => {
    const [canRenderFallback, setCanRenderFallback] = useState(!source);
    const videoRef = useRef(null);
    const { ref: inViewRef, inView } = useInView();
    const composedRefs = useComposedRefs(videoRef, inViewRef, forwardedRef);

    useEffect(() => {
      if (videoRef.current) {
        if (inView) {
          videoRef.current.play();
        } else {
          videoRef.current.pause();
        }
      }
    }, [videoRef, inView]);

    if (canRenderFallback && fallbackImage) {
      return (
        <Image
          sources={fallbackImage.sources}
          alt={fallbackImage.alt}
          {...rest}
        />
      );
    }

    return (
      <video
        ref={composedRefs}
        src={source}
        autoPlay
        loop
        playsInline
        muted
        onError={() => setCanRenderFallback(true)}
        {...rest}
        data-testid="test-background-video"
      />
    );
  },
);

BackgroundVideo.propTypes = {
  source: PropTypes.string.isRequired,
  fallbackImage: PropTypes.shape({
    sources: ImageSourcesType.isRequired,
    alt: PropTypes.string,
  }),
};

BackgroundVideo.defaultProps = {
  fallbackImage: undefined,
};

export default BackgroundVideo;
